import createMetadataAPIOperations from '../../utils/api-metadata-operations';

const options = {
  name: 'groups',
  baseType: 'GROUPS',
  apiEndpoint: 'groups'
};

const defaultOperations = createMetadataAPIOperations(options);
const fetchGroups = defaultOperations.fetch;

// fetch a group and its descendants
const fetchGroupAndSubgroups = (groupId, headers) => dispatch => {
  if (!groupId) return Promise.resolve();
  const groupIds = [groupId].flat().filter(Boolean).join(',');
  return dispatch(fetchGroups({ params: { ancestor_group_id: groupIds }, headers }));
};

export default {
  ...defaultOperations,
  fetchGroupAndSubgroups
};
